<template lang="html">
    <div class="content">
        <template>

            <template v-if="step === 1">
                <p>Êtes-vous sûr de vouloir resynchroniser ce produit ?</p>
            </template>

            <div class="loader" v-if="step === 2">
                <img src="../../../assets/img/grid_loader.svg" />
                <p>Synchronisation du produit en cours</p>
            </div>

        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title:          'Synchronisation d\'un produit',
                icon:           'sync',
                step:           1
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                this.step++
                this.$eventHub.$emit('hide-modal-actions')

                this.axios.put(`/api/products/erp-synchro/${this.$route.params.id}`)
                    .then(res => {
                        let interval = setInterval(() => {

                            this.axios.get(`/api/products/${res.data.id}`)
                                .then(r => {
                                    if(!r.data.is_syncing) {
                                        clearInterval(interval)
                                        this.$eventHub.$emit('close-modal')
                                        this.$eventHub.$emit('reload-single')
                                    }
                                })

                        }, 3000);
                    })
                    .catch(err => console.log(err))
            }
        }

    }
</script>

<style lang="stylus" scoped>
    div.content
        padding 1rem 4rem

    .loader
        display flex
        flex-direction column
        align-items center
        width 100%
        padding 3rem 0

        img
            margin 0 0 3rem

</style>



// WEBPACK FOOTER //
// src/views/products/single/ResyncProduct.vue